// @flow

const SCALE_STEPS = [1, 1.25, 1.3, 1.5, 2, 2.25, 2.5, 3, 4, 5, 6, 7, 8, 9, 10];

export function getScaleStep (maxValue: number, count: number): number {
    const step = Math.ceil(maxValue / count);
    const order = step.toString().length - 1;
    let _scale = SCALE_STEPS.map(i => i * Math.pow(10, order));
    let index = 0;
    let curr = _scale[index];
    let pervDiff = Infinity;
    let diff = Math.abs(step - curr);
    while (diff < pervDiff) {
        index++;
        pervDiff = diff;
        curr = _scale[index];
        diff = Math.abs(step - curr);
    }
    return _scale[index - 1] < step ? _scale[index] : _scale[index - 1];
}

export function getChartMaxValue (maxValue: number, count: number): number {
    return getScaleStep(maxValue, count) * count;
}
